import React from 'react';

import { InfoCircleFill as InfoCircleIcon } from '@styled-icons/bootstrap/InfoCircleFill';
import { Warning as WarningIcon } from '@styled-icons/fluentui-system-filled/Warning';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button,
  Icon,
  Text,
  Input,
} from '@chakra-ui/react';

import { AlertRootProps } from 'components/Alert/Root';

interface DangerDeleteAlertProps extends AlertRootProps {
  data: {
    confirmText: string;
  };
}

const DangerDeleteAlert: React.FC<DangerDeleteAlertProps> = ({
  type,
  title,
  description,
  buttons,
  data,
  onConfirm,
  handleClose,
  ...restProps
}) => {
  const [inputValue, setInputValue] = React.useState<string>('');
  const confirmText = data?.confirmText || 'excluir';

  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const getAlertDescription = (
    descr?: string | (() => JSX.Element),
  ): string | JSX.Element => {
    if (descr) {
      return typeof descr === 'string' ? descr : descr();
    }

    return '';
  };

  const isConfirmTextValid =
    inputValue.localeCompare(confirmText, undefined, {
      sensitivity: 'accent',
    }) === 0;

  return (
    <AlertDialog
      isOpen
      isCentered
      motionPreset="scale"
      leastDestructiveRef={cancelRef}
      onClose={handleClose}
      size="lg"
      {...restProps}
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader display="flex" alignItems="center" gap={2}>
          {type === 'danger' ? (
            <Icon as={WarningIcon} w={6} h={6} color="red.500" />
          ) : (
            <Icon as={InfoCircleIcon} w={6} h={6} color="blue.300" />
          )}{' '}
          {title}
        </AlertDialogHeader>

        <AlertDialogCloseButton />

        <AlertDialogBody>
          <>
            {getAlertDescription(description)}

            <Text mt="2">
              Para confirmar a exclusão digite <strong>{confirmText}</strong> no
              campo abaixo:
            </Text>

            <Input
              mt="2"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </>
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={handleClose}>
            {buttons?.[0] || 'Cancelar'}
          </Button>

          <Button
            ml={3}
            isDisabled={!isConfirmTextValid}
            colorScheme={type === 'danger' ? 'red' : 'blue'}
            onClick={() => {
              if (onConfirm) onConfirm();
              handleClose();
            }}
          >
            {buttons?.[1] || 'Confirmar'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DangerDeleteAlert;
